import { FC, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import { Headline, Layout, Page, Sidebar, SideNav } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { AUTH_STORE_TOKEN } from '../../auth';
import { Topic, topics } from '../assets/topics';
import { AnvilMarkdown } from './anvil-markdown';

const TopicSidebar: FC<{ topic: Topic; activeSubtopicId: string }> = ({
    topic,
    activeSubtopicId,
}) => {
    const [authStore] = useDependencies(AUTH_STORE_TOKEN);
    const history = useHistory();

    return (
        <Sidebar localStorageKey="sidebar:docs">
            <SideNav title={topic.title}>
                {topic.subtopics
                    .filter(subtopic => !subtopic.filter || subtopic.filter(authStore))
                    .map(subtopic => (
                        <SideNav.Item
                            key={subtopic.id}
                            active={subtopic.id === activeSubtopicId}
                            onClick={() => {
                                history.push(`/docs/${topic.id}/${subtopic.id}`);
                            }}
                        >
                            {subtopic.title}
                        </SideNav.Item>
                    ))}
            </SideNav>
        </Sidebar>
    );
};

export const TopicPage: FC<{ topicId: string; subtopicId?: string }> = ({
    topicId,
    subtopicId,
}) => {
    useEffect(() => {
        document.querySelector('.Page__page')?.scrollTo(0, 0);
    }, [topicId, subtopicId]);

    let topic = topics.find(topic => topic.id === topicId);
    if (!topic) {
        topic = topics[0];
    } else if (subtopicId) {
        const subtopic = topic.subtopics.find(subtopic => subtopic.id === subtopicId);
        if (subtopic) {
            return (
                <Page
                    header={<Headline size="large">{subtopic.title}</Headline>}
                    sidebar={<TopicSidebar topic={topic} activeSubtopicId={subtopicId} />}
                >
                    <Layout>
                        <AnvilMarkdown>{subtopic.content}</AnvilMarkdown>
                    </Layout>
                </Page>
            );
        }
    }
    return <Redirect to={`/docs/${topic.id}/${topic.subtopics[0].id}`} />;
};
TopicPage.displayName = 'TopicPage';
